var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_3);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Sfumatura_senza_nome_3-2);\n      }\n\n      .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: url(#Sfumatura_senza_nome_3-3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 19.91,
    y1: -765.41,
    x2: 78.86,
    y2: -821.83,
    gradientTransform: "translate(0 -778.46) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ffbb36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff5176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f63395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a436d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f4eed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3-2",
    "data-name": "Sfumatura senza nome 3",
    x1: 3.29,
    y1: -782.76,
    x2: 62.24,
    y2: -839.19,
    xlinkHref: "#Sfumatura_senza_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3-3",
    "data-name": "Sfumatura senza nome 3",
    x1: 3.18,
    y1: -782.88,
    x2: 62.13,
    y2: -839.31,
    xlinkHref: "#Sfumatura_senza_nome_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.72,11.64c-2.08,0-3.83,1.69-3.83,3.83s1.69,3.83,3.83,3.83,3.83-1.69,3.83-3.83c-.06-2.14-1.75-3.83-3.83-3.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.77,32.5c0-8.84,7.15-15.99,15.99-15.99s15.99,7.15,15.99,15.99-7.15,15.99-15.99,15.99-15.99-7.15-15.99-15.99Zm5.72,0c0,5.65,4.61,10.27,10.27,10.27s10.27-4.61,10.27-10.27-4.61-10.27-10.27-10.27-10.27,4.61-10.27,10.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m19.5,65h26c10.72,0,19.5-8.77,19.5-19.5v-26c0-10.72-8.71-19.5-19.5-19.5h-26C8.77,0,0,8.77,0,19.5v26C0,56.23,8.77,65,19.5,65ZM6.11,19.5c0-7.34,6.04-13.39,13.39-13.39h26c7.34,0,13.39,5.98,13.39,13.39v26c0,7.34-5.98,13.39-13.39,13.39h-26c-7.35,0-13.39-5.98-13.39-13.39v-26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1bc972a42e37ad743440b29ac52e72d8.svg";
export { ForwardRef as ReactComponent };